<template>
  <div  class="tab-item challenges row">
                    <div class="col-lg-2 col-sm-2 iconleft"> <img src="/static/img/ic-warn.png"></div>
                    <div class="col-lg-10 col-sm-10">
                      <div class="content">
                        <h1>{{ challenge.description }}</h1>
                         <p v-if="challenge.solution" class="mb-0 text-left">
      <span style="white-space: pre-wrap; overflow-wrap: break-word"
        ><strong>Ways to address the challenge</strong>: {{ challenge.solution
        }}<span v-if="challenge.solution.slice(-1) !== '.'">.</span> <br
      /></span></p>
                      </div>
                    </div>
  </div>
</template>

<script>
export default {
  name: "RecipeChallenge",
  props: {
    challenge: Object,
  },
};
</script>

<style scoped>
.media-wrapper {
  width: 64px;
  height: 64px;
}
</style>



// WEBPACK FOOTER //
// src/components/recipes/RecipeChallenge.vue